// MAMS frontend -> engine_alerts (Supabase). Od cutoveru 2026-09-04 bez n8n Alert Hub.
// Insert jako zalogowany user (RLS: rule='frontend'); niezalogowany -> cicho pomija.
// Nigdy nie rzuca wyjatkiem.
import { supabase } from '../supabaseClient';

const _lastSent = {};

export function reportAlert({ title, message, details, severity } = {}) {
  try {
    const key = String(title) + '|' + String(message);
    const now = Date.now();
    if (_lastSent[key] && now - _lastSent[key] < 60000) return; // dedup 60s
    _lastSent[key] = now;

    const sev = severity === 'warn' ? 'warn' : 'critical';
    const row = {
      rule: 'frontend',
      severity: sev,
      // klucz dedup (unikalny indeks engine_alerts_open_uniq: 1 otwarty alert per rule+order_id)
      order_id: 'fe:' + String(title || 'Frontend error').slice(0, 100),
      details: {
        source: 'frontend',
        title: title || 'Frontend error',
        message: message == null ? '' : String(message),
        details: details == null ? '' : String(details),
        link: typeof window !== 'undefined' ? window.location.href : '',
      },
    };
    supabase.from('engine_alerts').insert(row).then(() => {}, () => {});
  } catch (_e) {
    /* reporter nigdy nie psuje aplikacji */
  }
}

export function installGlobalAlertHandlers() {
  if (typeof window === 'undefined' || window.__mamsAlertInstalled) return;
  window.__mamsAlertInstalled = true;

  window.addEventListener('error', (ev) => {
    reportAlert({
      title: 'Frontend: nieobsluzony blad',
      message: (ev && ev.message) || 'window.onerror',
      details: ev && ev.filename ? `${ev.filename}:${ev.lineno || 0}` : '',
    });
  });

  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev && ev.reason;
    reportAlert({
      title: 'Frontend: nieobsluzona promesa',
      message: r && r.message ? r.message : String(r),
    });
  });
}
